export const WEIGHBRIDGE_DATE_FILTERS = [
  "All Dates",
  "Today",
  "Yesterday",
  "This Week",
  "Last 7 Days",
  "This Month",
];

export const getWeighbridgeTicketDateValue = (ticket = {}) => {
  const rawDate = ticket?.created_on || ticket?.time_in || ticket?.time_out || "";
  const parsedDate = rawDate ? new Date(rawDate) : null;

  if (!(parsedDate instanceof Date) || Number.isNaN(parsedDate?.getTime())) {
    return null;
  }

  return parsedDate;
};

const getStartOfDay = (date) => {
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);
  return start;
};

const getStartOfWeek = (date) => {
  const start = getStartOfDay(date);
  const currentDay = start.getDay();
  const daysFromMonday = currentDay === 0 ? 6 : currentDay - 1;
  start.setDate(start.getDate() - daysFromMonday);
  return start;
};

export const matchesWeighbridgeTicketDateFilter = (ticket, selectedDateFilter) => {
  if (selectedDateFilter === "All Dates") {
    return true;
  }

  const ticketDate = getWeighbridgeTicketDateValue(ticket);

  if (!ticketDate) {
    return false;
  }

  const now = new Date();
  const todayStart = getStartOfDay(now);
  const tomorrowStart = new Date(todayStart);
  tomorrowStart.setDate(tomorrowStart.getDate() + 1);

  if (selectedDateFilter === "Today") {
    return ticketDate >= todayStart && ticketDate < tomorrowStart;
  }

  if (selectedDateFilter === "Yesterday") {
    const yesterdayStart = new Date(todayStart);
    yesterdayStart.setDate(yesterdayStart.getDate() - 1);
    return ticketDate >= yesterdayStart && ticketDate < todayStart;
  }

  if (selectedDateFilter === "This Week") {
    const weekStart = getStartOfWeek(now);
    return ticketDate >= weekStart && ticketDate < tomorrowStart;
  }

  if (selectedDateFilter === "Last 7 Days") {
    const lastSevenDaysStart = getStartOfDay(now);
    lastSevenDaysStart.setDate(lastSevenDaysStart.getDate() - 6);
    return ticketDate >= lastSevenDaysStart && ticketDate < tomorrowStart;
  }

  if (selectedDateFilter === "This Month") {
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    return ticketDate >= monthStart && ticketDate < tomorrowStart;
  }

  return true;
};
